import { countryCodeToCountryName } from "@/utils/countries.util";
import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { HiOutlineBuildingOffice } from "react-icons/hi2";

import BaseColumn from "@/components/molecules/table/BaseColumn";
import { searchColumns } from "@/components/organisms/search/searchColumns";

const hqAddressColumn = (t: TFunction): ColumnDef<CompanyEntryDto> =>
  BaseColumn<CompanyEntryDto>({
    accessorFn: (row) => {
      const office = row.office_hq;

      if (!office || !office.address) return null;

      const { city, country_code } = office.address;
      const countryName = countryCodeToCountryName(country_code);

      const formattedAddress = [city, countryName].filter((value) => value && value.trim()).join(", ");

      return formattedAddress || null;
    },
    id: searchColumns(t).hq.id,
    size: 300,
    header: () => searchColumns(t).hq.name,
    cell: (info) => info.getValue<string>(),
    meta: {
      heading: {
        icon: HiOutlineBuildingOffice,
        className: "!bg-var-warning-100 hover:!bg-var-warning-200 active:!bg-var-warning-300",
      },
      column: {
        className: "bg-var-warning-50",
      },
    },
  });

export default hqAddressColumn;
